import React, { useEffect } from 'react';
import { Input, Form, DatePicker, Button, Row, Col, Icon, Dropdown, Menu, Drawer, Divider } from 'antd';
import { RemoveEmptyEle, removePropertyOfNull } from '../../../utils';

// 状态
import { connect } from 'react-redux';
import { clientlistAc } from '../../../redux/actions';

import moment from "moment";

const { RangePicker } = DatePicker;

const mapStateToProps = (state) => {
	return {
		state: state.clientRd,
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		set: (value) => dispatch(clientlistAc.SET(value)),
	}
}


// 渲染可搜索项目的组件
const SearchItems = connect(mapStateToProps, mapDispatchToProps)(Form.create()(function SearchItems({ form, onFinish, state }) {

	// form props
	const formLargeItemLayout = {
		labelCol: {
			span: 4,
		},
		wrapperCol: {
			span: 18,
		},
	}
	// 提交按钮
	const handleSubmit = (e) => {
		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				//清空一下空数据				
				onFinish(removePropertyOfNull(values));
			}
		});
	}

	return (
		<Form  {...formLargeItemLayout}  >
			<Col gutter={24}>
				<Col span={5} >

					<Form.Item

						label='客户'
					>
						{form.getFieldDecorator('cust_name', {
						})(
							<Input placeholder="客户名称" />
						)}
					</Form.Item>

				</Col>
				<Col span={8} >
					<Form.Item

						label='审核日期'
					>
						{form.getFieldDecorator('approver_time', {
						})(
							<RangePicker showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('00:00:00', 'HH:mm:ss')] }} />
						)}

					</Form.Item>
				</Col>
				{/** 渲染额外项目 */}
				{
					state.optionalSearchItems.addedExtraItems && state.optionalSearchItems.addedExtraItems.map(item => {
						return (
							<Col span={5} >

								<Form.Item

									label={item.title}
								>
									{form.getFieldDecorator(item.formFieldName, {
									})(
										item.element
									)}
								</Form.Item>

							</Col>
						)
					})
				}
				<Col span={2}  >
					<Button type="primary" onClick={handleSubmit}>   <Icon type="search" /> 查询</Button>
				</Col>
			</Col>
		</Form>
	)
})
)

const DropAdd = connect(mapStateToProps, mapDispatchToProps)(function DropAdd({ set, state }) {

	useEffect(() => {
		set({
			optionalSearchItems: {
				extraItems: [
					{
						title: "状态",
						formFieldName: "status",
						element: (<Input placeholder="状态" />)
					},
					{
						title: "SAP编码",
						formFieldName: "sap_no",
						element: (<Input placeholder="SAP编码" />)
					},
				],
				addedExtraItems: []
			}
		});
	}, []);

	return (
		<>
			<Divider type="vertical" />
			<Dropdown overlay={
				<Menu>
					{
						state.optionalSearchItems.extraItems && state.optionalSearchItems.extraItems.map((item, i) => {
							return (
								<Menu.Item key={item.title} onClick={() => {
									// 获取原来的按钮列表
									const newExtraItems = [...state.optionalSearchItems.extraItems];
									// 删除被添加的项目，并且存储被添加的项目
									const clickedItem = newExtraItems.splice(i, 1)[0];

									// 设置新的 state
									set({
										optionalSearchItems: {
											// 这个是已经删除了添加项目的列表
											extraItems: newExtraItems,
											// 已添加的搜索变为原来的和新添加的
											addedExtraItems: [...state.optionalSearchItems.addedExtraItems, clickedItem],
										}
									})
								}}>
									{item.title}
								</Menu.Item>
							)
						})
					}
				</Menu>
			}>
				<Button>
					添加更多搜索项 <Icon type="down" />
				</Button>
			</Dropdown>
		</>
	)
})

export {
	DropAdd,
	SearchItems
}
